import { Component, Input, OnInit } from '@angular/core';
import { MbIcon } from '@am/moebius';

@Component({
  selector: 'am-outstanding-promo',
  styleUrls: ['./outstanding-promo.component.scss'],
  templateUrl: './outstanding-promo.component.html',
  imports: [MbIcon],
})
export class OutstandingPromoComponent implements OnInit {
  @Input()
  public offer: any;

  constructor() {}

  public ngOnInit() {}
}
